import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        restUrl: null,
        user: {
            currentAccount: '',
            currentName: ''
        }
    },
    mutations: {
        setRestUrl (state) {
            const protocol = window.location.protocol
            const hostName = window.location.hostname
            const url = protocol + '//' + hostName + (process.env.NODE_ENV === 'production' ? window.location.port + '/doc/api' : ':3001')
            state.restUrl = url
        },
        setUser (state, value) {
            state.user = Object.assign({
                currentAccount: '',
                currentName: ''
            }, value)
        }
    },
    actions: {},
    modules: {}
})
